import { Flex, Text, Select, Box } from '@chakra-ui/core'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useFormStepContext } from '../../FormStepContext'
import useLocaleText from 'components/useLocaleText'
import { ErrorMessage } from 'components/TasksV2/UI/ErrorMessage'

export const AllowedOverdueDays = () => {
  const { control, watch, errors } = useFormContext()
  const { maxAllowedOverdueDays } = useFormStepContext()
  const allowedOverdueDays = watch('allowed_overdue_days')

  const t_allowedOverdue = useLocaleText('allowed_overdue')
  const t_allowedOverdue_error = useLocaleText('t_empty_field')
  const t_choose = useLocaleText('choose') || 'Choose'

  const maxDays = maxAllowedOverdueDays

  return (
    <Box>
      <Flex alignItems="center" style={{ columnGap: '10px' }} mb="5px">
        <Text>{t_allowedOverdue}</Text>
        <Controller
          name="allowed_overdue_days"
          control={control}
          rules={{
            validate: (value) => {
              if (value === null || value === undefined || value === '') {
                return t_allowedOverdue_error
              }
              return true
            },
          }}
          as={
            <Select
              width="100%"
              maxWidth="max-content"
              height="32px"
              textAlign="center"
              border="none"
              boxShadow={!errors?.allowed_overdue_days ? '0px 2px 6px 0px #dcdcdc' : '0px 0px 0px 3px #EA9999'}
              borderRadius="7px"
              _focus={{
                boxShadow: '0px 2px 6px 0px #dcdcdc',
                outline: 'none',
              }}
              value={allowedOverdueDays === null || allowedOverdueDays === undefined ? '' : allowedOverdueDays}
              onChange={(e) => {
                const value = e.target.value === '' ? null : parseInt(e.target.value, 10)
                control.setValue('allowed_overdue_days', value)
              }}
            >
              <option value="">{t_choose}</option>
              {Array.from({ length: maxDays }, (_, i) => i).map((num) => (
                <option key={num} value={num}>
                  {num}
                </option>
              ))}
            </Select>
          }
        />
      </Flex>
      {errors?.allowed_overdue_days && (
        <Box px="10px" pt="5px">
          <ErrorMessage errorMessage={t_allowedOverdue_error} />
        </Box>
      )}
    </Box>
  )
}
